module.exports = __webpack_public_path__ + "img/weekly-calendar.d2a4b312.png";